import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://penbqujlrhgejxdwreen.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbmJxdWpscmhnZWp4ZHdyZWVuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEzODg5MDEsImV4cCI6MjA4Njk2NDkwMX0.3PuO8JiUtptdVdbThGoeK1HdDeg7AxbtPThCGtOlfX8'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
